import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import {AuthEnum} from '@/store/auth/auth.enum';
import {LoginForm, LoginFromLine, LoginInfo, Weak} from '@/store/auth/auth.types';
import {AppResponseData, ResponseMessages} from '@/class/http';

export class HttpService {
  public static async getToken() {
    try {
      let loginInfo: LoginInfo = await JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
      if (!!loginInfo) {
        return loginInfo.token;
      } else {
        return undefined;
      }
    } catch (e) {
      return undefined;
    }
  }

  public static handleErrorAuthorization(res: AxiosResponse) {
    let unauthorized: boolean = false;
    unauthorized = res.status === 401;
    let {data} = res as { data: AppResponseData };
    unauthorized = ((data.appCode === 50002) || unauthorized);
    if (unauthorized) {
      console.log('DEBUG: data.token', data.logToken);
      localStorage.removeItem(AuthEnum.Auth);
      window.location.href = '/';
    }
    return;
  }

  public static async Authorization(): Promise<boolean> {
    try {
      return !!await HttpService.getToken();
    } catch (e) {
      return false;
    }
  }

  public static async weakPassword(): Promise<boolean> {
    try {
      let weak = await JSON.parse(localStorage.getItem(AuthEnum.weakPassword) as string) as Weak
      return weak.weakPassword
    } catch (e) {
      HttpService.handleErrorAuthorization(e.response);
      return false;
    }
  }

  public static async post(url: string, item: any, baseUrl?: any): Promise<any> {
    try {
      let a = await HttpService.axiosCreate(baseUrl ? baseUrl : process.env.VUE_APP_API_URL);
      return await a.post(url, item);
    } catch (e) {
      HttpService.handleErrorAuthorization(e.response);
      return e.response
      // console.error('DEBUG: post ', e.message);
    }
  }

  public static async postForLogin(url: string, item: any, baseUrl?: any): Promise<any> {
    try {
      let a = await HttpService.axiosCreate(baseUrl ? baseUrl : process.env.VUE_APP_API_URL);
      return await a.post(url, item);
    } catch (e) {
      return e.response
      // console.error('DEBUG: post ', e.message);
    }
  }

  public static async put(url: string, item: any, baseUrl?: any): Promise<any> {
    try {
      let a = await HttpService.axiosCreate(baseUrl ? baseUrl : process.env.VUE_APP_API_URL);
      return await a.put(url, item);
    } catch (e) {
      HttpService.handleErrorAuthorization(e.response);
      return e.response
      // console.error('DEBUG: post ', e.message);
    }
  }

  public static async delete(url: string, id: string, baseUrl?: any): Promise<any> {
    try {
      let a = await HttpService.axiosCreate(baseUrl ? baseUrl : process.env.VUE_APP_API_URL);
      return await a.delete(`${url}${id}`);
    } catch (e) {
      HttpService.handleErrorAuthorization(e.response);
    }
  }


  public static async get(url: string, queryParam?: any, baseUrl?: any): Promise<any> {
    try {
      let param: string = '';
      if (queryParam) {
        param = '?' +
          Object.keys(queryParam).map((key) => {
            if (queryParam[key]) {
              return encodeURIComponent(key) + '=' +
                encodeURIComponent(queryParam[key]) + '&';
            } else {
              return;
            }
          }).join('');
      }
      let a = await HttpService.axiosCreate(baseUrl ? baseUrl : process.env.VUE_APP_API_URL);
      return await a.get(url + param);
    } catch (e) {
      HttpService.handleErrorAuthorization(e.response);
      return e.response;
    }
  }

  public static axiosCreate(baseUrl: string): Promise<AxiosInstance> {
    return new Promise<AxiosInstance>(async (resolve, reject) => {
      let a = await axios.create({
        baseURL: baseUrl ? baseUrl : process.env.VUE_APP_API_URL,
        responseType: 'json',
        headers: {
          Authorization: await HttpService.getToken()
        }
      });
      resolve(a)
    })
  }

  public static async AuthorizationForce({customer}: { customer: LoginForm }) {
    try {
      // let customer: LoginForm = {
      //   email: 'nungpothi.p@gmail.com',
      //   password: 'admin1234',
      //   rememberMe: false,
      //   lineToken:'asd'
      // };
      let auth = await HttpService.post('/auth/login', customer, process.env.VUE_APP_API_AUTH) as { data: ResponseMessages };
      let loginInfo: LoginInfo[] = auth.data.data;
      localStorage.setItem(AuthEnum.Auth, JSON.stringify(loginInfo[0]));
    } catch (e) {
      return false;
    }
  }

  public static async LoginWithLine({customer}: { customer: LoginFromLine }) {
    try {
      let auth = await HttpService.post('/auth/login/line', customer, process.env.VUE_APP_API_AUTH) as { data: ResponseMessages };
      let loginInfo: LoginInfo[] = auth.data.data;
      localStorage.setItem(AuthEnum.Auth, JSON.stringify(loginInfo[0]));
      return loginInfo[0]
    } catch (e) {
      return false;
    }
  }

}
